
import { Options } from "vue-class-component";
import ComponentConfigMixins from "../ComponentConfigMixins";

@Options({
    name: "flowable-common-form-components-text-input-config",
})
export default class TextInputConfig extends ComponentConfigMixins {}
